import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = { class: "bb-fspec__trigger-text" }
const _hoisted_3 = {
  key: 0,
  class: "bb-fspec__kbd"
}
const _hoisted_4 = {
  key: 1,
  class: "bb-fspec__tour-progress"
}
const _hoisted_5 = { class: "bb-fspec__head" }
const _hoisted_6 = { class: "bb-fspec__guide-cta" }
const _hoisted_7 = { class: "bb-fspec__guide-actions" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "bb-fspec__search" }
const _hoisted_11 = { class: "bb-fspec__summary" }
const _hoisted_12 = { class: "bb-fspec__section" }
const _hoisted_13 = { class: "bb-fspec__section" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "bb-fspec__empty"
}
const _hoisted_16 = { class: "bb-fspec__feature-list" }
const _hoisted_17 = { class: "bb-fspec__feature-idx" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "bb-fspec__feature-top" }
const _hoisted_20 = {
  key: 0,
  class: "bb-fspec__badge"
}
const _hoisted_21 = {
  key: 1,
  class: "bb-fspec__badge is-soft"
}
const _hoisted_22 = { class: "bb-fspec__feature-desc" }
const _hoisted_23 = {
  key: 1,
  class: "bb-fspec__feature-static"
}
const _hoisted_24 = { class: "bb-fspec__feature-top" }
const _hoisted_25 = { class: "bb-fspec__feature-desc" }
const _hoisted_26 = {
  key: 0,
  class: "bb-fspec__section"
}
const _hoisted_27 = { class: "bb-fspec__notes" }
const _hoisted_28 = ["aria-label"]
const _hoisted_29 = { class: "bb-fspec-tour__progress" }
const _hoisted_30 = { class: "bb-fspec-tour__meta" }
const _hoisted_31 = {
  key: 0,
  class: "bb-fspec-tour__auto"
}
const _hoisted_32 = {
  key: 1,
  class: "bb-fspec-tour__auto"
}
const _hoisted_33 = {
  key: 2,
  class: "bb-fspec-tour__warn"
}
const _hoisted_34 = {
  key: 0,
  class: "bb-fspec-tour__status"
}
const _hoisted_35 = { class: "bb-fspec-tour__nav" }
const _hoisted_36 = { class: "bb-fspec-tour__nav-main" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "bb-fspec-done",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "안내 완료"
}
const _hoisted_40 = { class: "bb-fspec-done__card" }
const _hoisted_41 = { class: "bb-fspec-done__icon" }
const _hoisted_42 = { class: "bb-fspec-done__actions" }

import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import type {
  BankbookGuideHost,
  BankbookTestFeatureItem,
  BankbookTestFeatureSpec,
} from '@/constants/bankbookTestFeatureSpec';

/** 화면 따라가기 핵심 순서 (탭·모달 전환 포함) */
const AUTO_STEP_MS = 3200;
const SPOT_PAD = 8;


export default /*@__PURE__*/_defineComponent({
  __name: 'BankbookFeatureSpecPanel',
  props: {
    spec: {},
    guideHost: {}
  },
  setup(__props: any) {

const GUIDE_FLOW = [
  'bb-test-ym',
  'bb-test-banks',
  'bb-test-bank-manage',
  'bb-test-steps',
  'bb-test-summary',
  'bb-test-conditions',
  'bb-test-upload-quick',
  'bb-test-auto',
  'bb-test-ledger',
  'bb-test-account',
  'bb-test-recommend-settings',
  'bb-test-patterns',
  'bb-test-pairs',
  'bb-test-rel',
  'bb-test-funding',
  'bb-test-quick-edit',
  'bb-test-split',
  'bb-test-collection',
  'bb-test-collection-excel',
  'bb-test-receipt',
  'bb-test-analysis',
  'bb-test-closing',
] as const;

/** 모달/패널이 열렸을 때 우선 하이라이트 · 없으면 탭·버튼으로 친절히 폴백 */
const GUIDE_SPOT_FALLBACKS: Record<string, string[]> = {
  'bb-test-steps': [
    '[data-tour="bb-test-steps"]',
  ],
  'bb-test-summary': [
    '[data-tour="bb-test-summary"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-conditions': [
    '[data-tour="bb-test-conditions"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-ledger': [
    '[data-tour="bb-test-ledger"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-account': [
    '[data-tour="bb-test-account"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-rel': [
    '[data-tour="bb-test-rel"]',
    '[data-tour="bb-test-account"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-funding': [
    '[data-tour="bb-test-funding"]',
    '[data-tour="bb-test-account"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-quick-edit': [
    '[data-tour="bb-test-quick-edit"]',
    '[data-tour="bb-test-account"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-auto': [
    '[data-tour="bb-test-auto-dialog"]',
    '[data-tour="bb-test-auto"]',
  ],
  'bb-test-split': [
    '[data-tour="bb-test-split"]',
    '[data-tour="bb-test-account"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-closing': [
    '[data-tour="bb-test-closing"]',
    '[data-tour="bb-test-steps"]',
  ],
  'bb-test-heumieum': [
    '[data-tour="bb-test-heumieum"]',
    '[data-tour="bb-test-closing"]',
  ],
  'bb-test-patterns': [
    '[data-tour="bb-test-patterns-dialog"]',
    '[data-tour="bb-test-patterns"]',
    '[data-tour="bb-test-recommend-settings"]',
    '[data-tour="bb-test-account"]',
  ],
  'bb-test-pairs': [
    '[data-tour="bb-test-pairs-dialog"]',
    '[data-tour="bb-test-pairs"]',
    '[data-tour="bb-test-recommend-settings"]',
    '[data-tour="bb-test-account"]',
  ],
  'bb-test-recommend-settings': [
    '[data-tour="bb-test-recommend-panel"]',
    '[data-tour="bb-test-recommend-settings"]',
    '[data-tour="bb-test-account"]',
  ],
  'bb-test-upload-quick': [
    '[data-tour="bb-test-upload-dialog"]',
    '[data-tour="bb-test-upload-quick"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-bank-manage': [
    '[data-tour="bb-test-bank-manage-dialog"]',
    '[data-tour="bb-test-bank-manage"]',
    '[data-tour="bb-test-banks"]',
  ],
  'bb-test-collection-excel': [
    '[data-tour="bb-test-collection-excel-dialog"]',
    '[data-tour="bb-test-collection-excel"]',
    '[data-tour="bb-test-collection"]',
    '[data-tour="bb-test-collection-tab"]',
  ],
  'bb-test-labor': [
    '[data-tour="bb-test-labor-dialog"]',
    '[data-tour="bb-test-labor"]',
    '[data-tour="bb-test-summary"]',
  ],
  'bb-test-settlement': [
    '[data-tour="bb-test-settlement-dialog"]',
    '[data-tour="bb-test-settlement"]',
    '[data-tour="bb-test-raw-tab"]',
  ],
  'bb-test-receipt': [
    '[data-tour="bb-test-receipt"]',
    '[data-tour="bb-test-receipt-tab"]',
    '[data-tour="bb-test-steps"]',
  ],
  'bb-test-collection': [
    '[data-tour="bb-test-collection"]',
    '[data-tour="bb-test-collection-tab"]',
    '[data-tour="bb-test-steps"]',
  ],
  'bb-test-analysis': [
    '[data-tour="bb-test-analysis"]',
    '[data-tour="bb-test-analysis-tab"]',
    '[data-tour="bb-test-steps"]',
  ],
};

const GUIDE_SET = new Set<string>(GUIDE_FLOW);
const props = __props;

const open = ref(false);
const query = ref('');
const rootRef = ref<HTMLElement | null>(null);
const searchInputRef = ref<HTMLInputElement | null>(null);

const touring = ref(false);
const tourAuto = ref(false);
const tourBooting = ref(false);
const tourPreparing = ref(false);
const tourIndex = ref(0);
const tourSteps = ref<BankbookTestFeatureItem[]>([]);
const tourStatus = ref('');
const tourDoneShown = ref(false);
const spotExtraSelectors = ref<string[]>([]);
const spotRect = ref<DOMRect | null>(null);
const cardPos = ref({ top: 24, left: 24 });

let highlightTimer: ReturnType<typeof setTimeout> | null = null;
let autoTimer: ReturnType<typeof setTimeout> | null = null;
let spotRaf = 0;
let tourSeq = 0;

const filteredFeatures = computed(() => {
  const q = query.value.trim().toLowerCase();
  const list = props.spec.features || [];
  if (!q) return list;
  return list.filter((item) => {
    const bag = [item.name, item.description, ...(item.keywords || [])].join(' ').toLowerCase();
    return bag.includes(q);
  });
});

const currentTourItem = computed(() => tourSteps.value[tourIndex.value] || null);

const spotStyle = computed(() => {
  const r = spotRect.value;
  if (!r) {
    return {
      top: '40%',
      left: '50%',
      width: '0px',
      height: '0px',
      opacity: '0',
    };
  }
  return {
    top: `${Math.max(4, r.top - SPOT_PAD)}px`,
    left: `${Math.max(4, r.left - SPOT_PAD)}px`,
    width: `${r.width + SPOT_PAD * 2}px`,
    height: `${r.height + SPOT_PAD * 2}px`,
    opacity: '1',
  };
});

const cardStyle = computed(() => ({
  top: `${cardPos.value.top}px`,
  left: `${cardPos.value.left}px`,
}));

const isGuideTarget = (target?: string) => !!target && GUIDE_SET.has(target);

watch(open, async (value) => {
  if (!value) return;
  await nextTick();
  if (window.matchMedia('(pointer: fine)').matches) {
    searchInputRef.value?.focus();
  }
});

const clearHighlight = () => {
  document.querySelectorAll('.bb-fspec-pulse').forEach((el) => el.classList.remove('bb-fspec-pulse'));
  if (highlightTimer) {
    clearTimeout(highlightTimer);
    highlightTimer = null;
  }
};

const clearAuto = () => {
  if (autoTimer) {
    clearTimeout(autoTimer);
    autoTimer = null;
  }
};

const stopSpotWatch = () => {
  if (spotRaf) {
    cancelAnimationFrame(spotRaf);
    spotRaf = 0;
  }
  window.removeEventListener('resize', scheduleSpotUpdate);
  window.removeEventListener('scroll', scheduleSpotUpdate, true);
};

const placeCard = (rect: DOMRect | null) => {
  const cardW = Math.min(360, window.innerWidth - 24);
  const cardH = 230;
  const pad = 14;
  if (!rect) {
    cardPos.value = {
      top: Math.max(pad, (window.innerHeight - cardH) / 2),
      left: Math.max(pad, (window.innerWidth - cardW) / 2),
    };
    return;
  }
  let top = rect.bottom + pad + SPOT_PAD;
  let left = Math.min(Math.max(pad, rect.left), window.innerWidth - cardW - pad);
  if (top + cardH > window.innerHeight - pad) {
    top = Math.max(pad, rect.top - cardH - pad - SPOT_PAD);
  }
  if (top < pad) top = pad;
  // 카드가 스포트라이트와 너무 겹치면 오른쪽으로
  if (
    left < rect.right &&
    left + cardW > rect.left &&
    top < rect.bottom &&
    top + cardH > rect.top
  ) {
    const right = rect.right + pad;
    if (right + cardW < window.innerWidth - pad) left = right;
  }
  cardPos.value = { top, left };
};

const resolveSpotEl = (target: string): HTMLElement | null => {
  const selectors = [
    ...spotExtraSelectors.value,
    ...(GUIDE_SPOT_FALLBACKS[target] || []),
    `[data-tour="${target}"]`,
  ];
  for (const sel of selectors) {
    if (!sel) continue;
    const el = document.querySelector(sel) as HTMLElement | null;
    if (!el) continue;
    const rect = el.getBoundingClientRect();
    // display:none / 아직 레이아웃 전(0크기)은 스킵
    if (rect.width < 2 && rect.height < 2) continue;
    return el;
  }
  return null;
};

const waitForSpotEl = async (target: string, timeoutMs = 800): Promise<HTMLElement | null> => {
  const started = performance.now();
  let el = resolveSpotEl(target);
  while (!el && performance.now() - started < timeoutMs) {
    await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
    el = resolveSpotEl(target);
  }
  return el;
};

const updateSpot = () => {
  const item = currentTourItem.value;
  if (!item?.target) {
    spotRect.value = null;
    placeCard(null);
    return;
  }
  const el = resolveSpotEl(item.target);
  if (!el) {
    spotRect.value = null;
    placeCard(null);
    return;
  }
  const rect = el.getBoundingClientRect();
  spotRect.value = rect;
  placeCard(rect);
};

const scheduleSpotUpdate = () => {
  if (spotRaf) cancelAnimationFrame(spotRaf);
  spotRaf = requestAnimationFrame(() => {
    spotRaf = 0;
    updateSpot();
  });
};

const prepareAndFocus = async (seq: number) => {
  tourPreparing.value = true;
  const item = currentTourItem.value;
  spotExtraSelectors.value = [];
  try {
    if (item?.target && props.guideHost?.prepare) {
      const result = await props.guideHost.prepare(item.target);
      if (seq !== tourSeq) return;
      if (result?.spotSelectors?.length) {
        spotExtraSelectors.value = result.spotSelectors;
      }
      tourStatus.value = result?.status || '';
    }
    await nextTick();
    if (seq !== tourSeq) return;
    const el = item?.target ? await waitForSpotEl(item.target) : null;
    if (seq !== tourSeq) return;
    el?.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });
    updateSpot();
  } finally {
    if (seq === tourSeq) tourPreparing.value = false;
  }
};

const finishTour = () => {
  stopTour();
  tourDoneShown.value = true;
  props.guideHost?.notify?.('안내를 모두 봤습니다. 잘하셨어요!', 'success');
};

const scheduleAutoAdvance = () => {
  clearAuto();
  if (!touring.value || !tourAuto.value) return;
  autoTimer = setTimeout(() => {
    void (async () => {
      if (tourIndex.value >= tourSteps.value.length - 1) {
        finishTour();
        return;
      }
      tourIndex.value += 1;
      const seq = ++tourSeq;
      await prepareAndFocus(seq);
      scheduleAutoAdvance();
    })();
  }, AUTO_STEP_MS);
};

const buildTourSteps = (): BankbookTestFeatureItem[] => {
  const byTarget = new Map(
    (props.spec.features || [])
      .filter((f) => f.target)
      .map((f) => [f.target as string, f])
  );
  const steps: BankbookTestFeatureItem[] = [];
  for (const target of GUIDE_FLOW) {
    const item = byTarget.get(target);
    if (item) steps.push(item);
  }
  return steps;
};

const restartFromDone = () => {
  tourDoneShown.value = false;
  void startTour(false);
};

const startTour = async (auto: boolean) => {
  const steps = buildTourSteps();
  if (!steps.length) return;

  tourDoneShown.value = false;
  clearHighlight();
  clearAuto();
  tourBooting.value = true;
  tourStatus.value = '';
  props.guideHost?.notify?.('안내를 준비하는 중이에요…', 'info');

  try {
    if (props.guideHost?.ensureData) {
      const ensured = await props.guideHost.ensureData();
      if (ensured.message) tourStatus.value = ensured.message;
      if (ensured.cancelled) {
        props.guideHost.notify?.('안내를 취소했습니다.', 'warn');
        return;
      }
      if (!ensured.ok) {
        window.alert(
          ensured.message ||
            '지금은 안내를 시작할 수 없습니다.\n통장이 등록돼 있는지 확인해 주세요.'
        );
        props.guideHost.notify?.(ensured.message || '안내를 시작할 수 없습니다.', 'warn');
        return;
      }
    }
  } finally {
    tourBooting.value = false;
  }

  open.value = false;
  query.value = '';
  tourSteps.value = steps;
  tourIndex.value = 0;
  tourAuto.value = auto;
  touring.value = true;
  window.addEventListener('resize', scheduleSpotUpdate);
  window.addEventListener('scroll', scheduleSpotUpdate, true);
  props.guideHost?.notify?.('밝은 부분을 따라가 보세요.', 'success');
  const seq = ++tourSeq;
  await prepareAndFocus(seq);
  if (auto) scheduleAutoAdvance();
};

const stopTour = (opts?: { ask?: boolean }) => {
  // opts.ask는 더 이상 confirm을 띄우지 않고 즉시 종료 (UX: 비차단)
  void opts;
  const wasTouring = touring.value;
  tourSeq += 1;
  touring.value = false;
  tourAuto.value = false;
  tourPreparing.value = false;
  tourBooting.value = false;
  tourIndex.value = 0;
  tourSteps.value = [];
  spotRect.value = null;
  spotExtraSelectors.value = [];
  tourStatus.value = '';
  clearAuto();
  stopSpotWatch();
  props.guideHost?.cleanup?.();
  if (wasTouring && opts?.ask) {
    props.guideHost?.notify?.('안내를 멈췄습니다. 언제든 다시 볼 수 있어요.', 'info');
  }
};

const nextTourStep = () => {
  tourAuto.value = false;
  clearAuto();
  if (tourIndex.value >= tourSteps.value.length - 1) {
    finishTour();
    return;
  }
  tourIndex.value += 1;
  const seq = ++tourSeq;
  void prepareAndFocus(seq);
};

const prevTourStep = () => {
  if (tourIndex.value <= 0) return;
  tourAuto.value = false;
  clearAuto();
  tourIndex.value -= 1;
  const seq = ++tourSeq;
  void prepareAndFocus(seq);
};

const onTourBackdrop = () => {
  if (tourPreparing.value) return;
  nextTourStep();
};

const togglePanel = () => {
  if (touring.value) {
    stopTour({ ask: true });
    if (touring.value) return;
  }
  open.value = !open.value;
  if (!open.value) query.value = '';
};

const closePanel = () => {
  open.value = false;
  query.value = '';
};

const highlightFeature = async (item: BankbookTestFeatureItem) => {
  if (!item.target) return;
  clearHighlight();
  closePanel();
  spotExtraSelectors.value = [];
  props.guideHost?.notify?.(`「${item.name}」 자리를 보여 드릴게요.`, 'info');
  if (props.guideHost?.prepare) {
    const result = await props.guideHost.prepare(item.target);
    if (result?.spotSelectors?.length) spotExtraSelectors.value = result.spotSelectors;
  }
  await nextTick();
  const el = await waitForSpotEl(item.target);
  if (!el) {
    props.guideHost?.notify?.('화면에서 위치를 찾지 못했습니다.', 'warn');
    return;
  }
  el.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });
  el.classList.add('bb-fspec-pulse');
  highlightTimer = setTimeout(() => {
    el.classList.remove('bb-fspec-pulse');
    highlightTimer = null;
    props.guideHost?.cleanup?.();
  }, 1800);
};

const onPanelKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    e.stopPropagation();
    closePanel();
  }
};

const onDocPointer = (e: MouseEvent) => {
  if (!open.value || !rootRef.value) return;
  if (!rootRef.value.contains(e.target as Node)) closePanel();
};

const onGlobalKey = (e: KeyboardEvent) => {
  if (touring.value) {
    if (e.key === 'Escape') {
      e.preventDefault();
      stopTour({ ask: true });
      return;
    }
    if (e.key === 'ArrowRight' || e.key === 'Enter') {
      e.preventDefault();
      nextTourStep();
      return;
    }
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevTourStep();
      return;
    }
  }
  if (!(e.ctrlKey || e.metaKey) || e.key.toLowerCase() !== 'k') return;
  const path = String(window.location.pathname || '');
  // 정식(bankbook) · (구)테스트(bankbook-test) 주소 모두 허용
  if (!path.includes('bankbook')) return;
  e.preventDefault();
  togglePanel();
};

onMounted(() => {
  document.addEventListener('mousedown', onDocPointer);
  window.addEventListener('keydown', onGlobalKey);
});

onUnmounted(() => {
  document.removeEventListener('mousedown', onDocPointer);
  window.removeEventListener('keydown', onGlobalKey);
  clearHighlight();
  stopTour();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bb-fspec",
    ref_key: "rootRef",
    ref: rootRef
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["bb-fspec__trigger", { 'is-open': open.value, 'is-touring': touring.value }]),
      "aria-expanded": open.value,
      "aria-controls": "bb-feature-spec",
      title: "이 화면 도움말 (Ctrl+K)",
      onClick: togglePanel
    }, [
      _createVNode(_component_v_icon, { size: "15" }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode("mdi-help-circle-outline", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("strong", null, "도움말", -1)),
        (!touring.value)
          ? (_openBlock(), _createElementBlock("kbd", _hoisted_3, "Ctrl K"))
          : (_openBlock(), _createElementBlock("em", _hoisted_4, "안내 " + _toDisplayString(tourIndex.value + 1) + "/" + _toDisplayString(tourSteps.value.length), 1))
      ])
    ], 10, _hoisted_1),
    _createVNode(_Transition, { name: "bb-fspec-pop" }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("aside", {
              key: 0,
              id: "bb-feature-spec",
              class: "bb-fspec__panel",
              role: "dialog",
              "aria-modal": "true",
              "aria-label": "화면 기능정의서",
              onKeydown: onPanelKeydown
            }, [
              _createElementVNode("header", _hoisted_5, [
                _createElementVNode("div", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("p", { class: "bb-fspec__eyebrow" }, "처음이어도 OK · 화면 안내", -1)),
                  _createElementVNode("h2", null, _toDisplayString(__props.spec.title), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "bb-fspec__close",
                  "aria-label": "닫기",
                  onClick: closePanel
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "bb-fspec__guide-copy" }, [
                  _createElementVNode("strong", null, "처음 쓰시나요? 여기서 시작하세요"),
                  _createElementVNode("span", null, " 화면이 알아서 탭·창을 열고 「여기가 그 기능」을 밝게 가리킵니다. 연습용 데이터가 없으면 만들어 줄지 물어봅니다. ")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "bb-fspec__guide-btn is-primary",
                    disabled: tourBooting.value,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (startTour(true)))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("mdi-play", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(tourBooting.value ? '준비 중…' : '자동으로 보기'), 1)
                  ], 8, _hoisted_8),
                  _createElementVNode("button", {
                    type: "button",
                    class: "bb-fspec__guide-btn",
                    disabled: tourBooting.value,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (startTour(false)))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("mdi-skip-next", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[13] || (_cache[13] = _createTextVNode(" 한 단계씩 보기 ", -1))
                  ], 8, _hoisted_9)
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "bb-fspec__guide-tip" }, " 추천: 「자동으로 보기」 · 멈추려면 Esc ", -1))
              ]),
              _createElementVNode("label", _hoisted_10, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("mdi-magnify", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("input", {
                  ref_key: "searchInputRef",
                  ref: searchInputRef,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((query).value = $event)),
                  type: "search",
                  placeholder: "궁금한 말 검색 (예: 영수증, 마감, 업로드)",
                  autocomplete: "off",
                  "aria-label": "기능 검색"
                }, null, 512), [
                  [
                    _vModelText,
                    query.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (query.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "bb-fspec__search-clear",
                      "aria-label": "검색어 지우기",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (query.value = ''))
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("mdi-close-circle", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_11, _toDisplayString(__props.spec.summary), 1),
              _createElementVNode("section", _hoisted_12, [
                _cache[18] || (_cache[18] = _createElementVNode("h3", null, "이 화면에서 하는 일", -1)),
                _createElementVNode("p", null, _toDisplayString(__props.spec.purpose), 1)
              ]),
              _createElementVNode("section", _hoisted_13, [
                _createElementVNode("h3", null, [
                  _cache[19] || (_cache[19] = _createTextVNode(" 기능 목록 ", -1)),
                  (filteredFeatures.value.length !== __props.spec.features.length)
                    ? (_openBlock(), _createElementBlock("em", _hoisted_14, "· " + _toDisplayString(filteredFeatures.value.length) + "건", 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "bb-fspec__section-hint" }, " 이름을 누르면 그 자리로 데려다 줍니다. (창을 열 때는 한 번 물어봅니다) ", -1)),
                (query.value && !filteredFeatures.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, "맞는 기능이 없습니다."))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFeatures.value, (item, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.name,
                      class: _normalizeClass(["bb-fspec__feature", [
                `tone-${idx % 5}`,
                { 'has-target': !!item.target, 'is-guide': isGuideTarget(item.target) },
              ]])
                    }, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(idx + 1), 1),
                      (item.target)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "bb-fspec__feature-btn",
                            onClick: ($event: any) => (highlightFeature(item))
                          }, [
                            _createElementVNode("span", _hoisted_19, [
                              _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                              (isGuideTarget(item.target))
                                ? (_openBlock(), _createElementBlock("em", _hoisted_20, "가이드"))
                                : (_openBlock(), _createElementBlock("em", _hoisted_21, "위치"))
                            ]),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(item.description), 1)
                          ], 8, _hoisted_18))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, [
                              _createElementVNode("strong", null, _toDisplayString(item.name), 1)
                            ]),
                            _createElementVNode("span", _hoisted_25, _toDisplayString(item.description), 1)
                          ]))
                    ], 2))
                  }), 128))
                ])
              ]),
              (__props.spec.notes?.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
                    _cache[21] || (_cache[21] = _createElementVNode("h3", null, "참고", -1)),
                    _createElementVNode("ul", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.spec.notes, (note) => {
                        return (_openBlock(), _createElementBlock("li", { key: note }, _toDisplayString(note), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "bb-fspec-tour-fade" }, {
        default: _withCtx(() => [
          (touring.value && currentTourItem.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["bb-fspec-tour", { 'is-done': tourDoneShown.value }]),
                role: "dialog",
                "aria-modal": "true",
                "aria-label": `기능 가이드 ${tourIndex.value + 1}`
              }, [
                _createElementVNode("div", {
                  class: "bb-fspec-tour__dim",
                  onClick: onTourBackdrop
                }),
                _createElementVNode("div", {
                  class: _normalizeClass(["bb-fspec-tour__spot", { 'is-missing': !spotRect.value }]),
                  style: _normalizeStyle(spotStyle.value)
                }, null, 6),
                (_openBlock(), _createElementBlock("div", {
                  key: tourIndex.value,
                  class: "bb-fspec-tour__card",
                  style: _normalizeStyle(cardStyle.value)
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", {
                      class: "bb-fspec-tour__progress-bar",
                      style: _normalizeStyle({ width: `${((tourIndex.value + 1) / Math.max(tourSteps.value.length, 1)) * 100}%` })
                    }, null, 4)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("em", null, _toDisplayString(tourIndex.value + 1) + " / " + _toDisplayString(tourSteps.value.length), 1),
                    (tourAuto.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "자동"))
                      : _createCommentVNode("", true),
                    (tourPreparing.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, "이동 중"))
                      : _createCommentVNode("", true),
                    (!spotRect.value && !tourPreparing.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, "가까운 위치를 보여 주는 중"))
                      : _createCommentVNode("", true)
                  ]),
                  (tourStatus.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(tourStatus.value), 1))
                    : _createCommentVNode("", true),
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "bb-fspec-tour__howto" }, "밝게 표시된 곳을 보세요. 그게 지금 설명하는 기능입니다.", -1)),
                  _createElementVNode("h3", null, _toDisplayString(currentTourItem.value.name), 1),
                  _createElementVNode("p", null, _toDisplayString(currentTourItem.value.description), 1),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "bb-fspec-tour__btn is-ghost",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (stopTour({ ask: true })))
                    }, "그만둘래요"),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "bb-fspec-tour__btn",
                        disabled: tourIndex.value <= 0 || tourPreparing.value,
                        onClick: prevTourStep
                      }, " 이전 ", 8, _hoisted_37),
                      _createElementVNode("button", {
                        type: "button",
                        class: "bb-fspec-tour__btn is-primary",
                        disabled: tourPreparing.value,
                        onClick: nextTourStep
                      }, _toDisplayString(tourIndex.value >= tourSteps.value.length - 1 ? '다 봤어요' : '다음으로'), 9, _hoisted_38)
                    ])
                  ])
                ], 4))
              ], 10, _hoisted_28))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "bb-fspec-tour-fade" }, {
        default: _withCtx(() => [
          (tourDoneShown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("div", {
                  class: "bb-fspec-done__dim",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (tourDoneShown.value = false))
                }),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_v_icon, { size: "26" }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-check-circle", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _cache[24] || (_cache[24] = _createElementVNode("h3", null, "화면 안내를 모두 봤습니다", -1)),
                  _cache[25] || (_cache[25] = _createElementVNode("p", null, [
                    _createTextVNode("다시 보고 싶으면 오른쪽 위 「도움말」을 눌러 주세요."),
                    _createElementVNode("br"),
                    _createTextVNode("궁금한 기능 이름을 검색해도 됩니다.")
                  ], -1)),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "bb-fspec-tour__btn",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (tourDoneShown.value = false))
                    }, "닫기"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "bb-fspec-tour__btn is-primary",
                      onClick: restartFromDone
                    }, "다시 보기")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 512))
}
}

})